/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class TranslationService {

    /**
     * @returns any
     * @throws ApiError
     */
    public static translationControllerGetTranslations(): CancelablePromise<any> {
        return __request({
            method: 'GET',
            path: `/translation`,
        });
    }

}